import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Typography } from '@mui/material';
export const SensorHeader = memo(function SensorHeader(props) {
    const { icon, is_violation, has_value_with_unit, value_with_unit, is_details, alarm, } = props;
    return (_jsx(Box, { display: "flex", columnGap: 0.2, width: "100%", fontSize: is_details ? '2rem' : '1em', justifyContent: icon ? 'space-between' : 'center', children: has_value_with_unit && (_jsx(Typography, { width: "100%", fontSize: "1em", color: is_violation && !alarm ? 'error' : 'inherit', title: value_with_unit, textAlign: "left", whiteSpace: "nowrap", children: value_with_unit })) }));
});
